import React, { useState, useContext } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import { useNavigate } from 'react-router-dom';
import { AuthContext } from '../../context/AuthContext';
import { toast } from 'react-toastify';

const Login = () => {
  const [step, setStep] = useState(1);
  const [loginData, setLoginData] = useState({ username: '', password: '', otp: '' });
  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(false); // Added loading state
  const { login } = useContext(AuthContext);
  const navigate = useNavigate();

  const handleChange = (e) => {
    const { name, value } = e.target;
    setLoginData((prev) => ({ ...prev, [name]: value }));
    setError(''); // Clear error on input change
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setIsLoading(true); // Show loading state

    try {
      if (step === 1) {
        const result = await login(loginData.username, loginData.password);
        console.log('Login result:', result); // Debug login result
        if (result.success) {
          navigate('/');
        } else if (result.otpRequired) {
          toast.success(result.message || 'OTP sent to your Telegram!');
          setStep(2);
          setLoginData((prev) => ({ ...prev, otp: '' }));
        } else {
          setError(result.message || 'Login failed');
          toast.error(result.message || 'Login failed');
        }
      } else if (step === 2) {
        const result = await login(loginData.username, loginData.password, loginData.otp);
        console.log('Verify OTP result:', result); // Debug OTP result
        if (result.success) {
          navigate('/');
        } else {
          setError(result.message || 'Invalid or expired OTP');
          toast.error(result.message || 'Invalid or expired OTP');
        }
      }
    } catch (error) {
      console.error('Unexpected error during login:', error);
      setError('An unexpected error occurred. Please try again.');
      toast.error('An unexpected error occurred. Please try again.');
    } finally {
      setIsLoading(false); // Reset loading state
    }
  };

  const handleBack = () => {
    setStep(1);
    setLoginData((prev) => ({ ...prev, otp: '' }));
    setError('');
  };

  return (
    <div className="container mt-5" key={step}>
      <h2 className="text-center">Login</h2>
      <div className="row justify-content-center">
        <div className="col-md-4">
          <form onSubmit={handleSubmit}>
            {step === 1 && (
              <>
                <div className="mb-3">
                  <label htmlFor="username" className="form-label">Username</label>
                  <input
                    type="text"
                    className="form-control"
                    id="username"
                    name="username"
                    value={loginData.username}
                    onChange={handleChange}
                    required
                    disabled={isLoading}
                  />
                </div>
                <div className="mb-3">
                  <label htmlFor="password" className="form-label">Password</label>
                  <input
                    type="password"
                    className="form-control"
                    id="password"
                    name="password"
                    value={loginData.password}
                    onChange={handleChange}
                    required
                    disabled={isLoading}
                  />
                </div>
              </>
            )}

            {step === 2 && (
              <>
                <div className="mb-3">
                  <label htmlFor="otp" className="form-label">Enter OTP</label>
                  <input
                    type="text"
                    className="form-control"
                    id="otp"
                    name="otp"
                    value={loginData.otp}
                    onChange={handleChange}
                    placeholder="6-digit OTP"
                    required
                    autoFocus
                    disabled={isLoading}
                  />
                </div>
                <button
                  type="button"
                  className="btn btn-secondary w-100 mb-2"
                  onClick={handleBack}
                  disabled={isLoading}
                >
                  Back to Login
                </button>
              </>
            )}

            {error && <div className="alert alert-danger">{error}</div>}
            <button type="submit" className="btn btn-primary w-100" disabled={isLoading}>
              {isLoading ? 'Loading...' : step === 1 ? 'Login' : 'Verify OTP'}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default Login;